export default __webpack_public_path__ + "adadaf456280fe8ba638671f1e498b21.png";